<script setup lang="ts">
import BottomSheetButton from './BottomSheetButton.vue'

const emits = defineEmits(['close'])

defineProps<{
  text: string
  buttonText: string
}>()
</script>
<template>
  <div class="flex flex-col gap-[12px]">
    <div
      class="font-['Be Vietnam Pro'] font-[700] text-[20px] leading-[100%] tracking-[0px] text-center"
    >
      {{ text }}
    </div>
  </div>

  <div class="flex flex-col text-[#fff]">
    <BottomSheetButton @click="emits('close')" data-testid="bottomSheetClose">
      {{ buttonText }}
    </BottomSheetButton>
  </div>
</template>
